// @ts-nocheck
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import {
  Card,
  Container,
  Typography,
  TextField,
  Box,
  FormControl,
  FormControlLabel,
  RadioGroup,
  FormLabel,
  Radio,
} from '@mui/material';
import { Formik } from 'formik';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Page from '../components/Page';
import * as Yup from 'yup';
import { getMessage } from '../components/message';
// sections
import { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useForgotPasswordMutation } from '../store/api/userApi';

// ----------------------------------------------------------------------
const SignInSchema = Yup.object().shape({
  email: Yup.string().email('Email must be a valid email').required('Email is required'),
});

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function ForgotPassword() {
  const [formValues, setFormValues] = useState({
    email: '',
    categoryType: 'UTSA',
  });
  const navigate = useNavigate();
  const [forgetPassword, forgetPasswordResponse] = useForgotPasswordMutation();
  const handleLogin = (values: any) => {
    forgetPassword({
      email: values.email,
      category: values.categoryType,
    });
  };

  useEffect(() => {
    if (forgetPasswordResponse.isSuccess) {
      toast.success(getMessage.SUCCESS_FORGOT_PASSWORD);
      navigate('/login');
    }
    if (forgetPasswordResponse.isError) {
      toast.error(getMessage.Error_FORGOT_PASSWORD);
    }
  }, [forgetPasswordResponse.isSuccess, forgetPasswordResponse.isError]);

  return (
    <Page title="Forgot Password">
      <RootStyle>
        <Container maxWidth="sm">
          <ContentStyle>
            <Typography variant="h4" gutterBottom>
              Forgot Password
            </Typography>
            <Formik
              enableReinitialize={true}
              initialValues={formValues}
              onSubmit={handleLogin}
              validationSchema={SignInSchema}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                <Box>
                  <FormControl sx={{ mb: 2 }}>
                    <FormLabel id="demo-row-radio-buttons-group-label"> Forgot password for:</FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="categoryType"
                      value={values.categoryType.toString()}
                      onChange={(event) => {
                        setFieldValue('categoryType', event.target.value);
                      }}
                      error={Boolean(touched.categoryType && errors.categoryType)}
                      helperText={touched.categoryType && errors.categoryType}
                    >
                      <FormControlLabel id="UTSA" value="UTSA" control={<Radio />} label="Admin" />
                      <FormControlLabel id="UTSP" value="UTSP" control={<Radio />} label="Vendor" />
                    </RadioGroup>
                  </FormControl>
                  <TextField
                    fullWidth
                    autoComplete="username"
                    type="email"
                    name="email"
                    label=" Enter Your Email address"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                  />

                  <button
                    class="button button1"
                    style={{
                      marginTop: '20px',
                      padding: '15px',
                      borderRadius: '10px',
                      backgroundColor: '#E23744',
                      color: 'White',
                      borderColor: '#E23744',
                      width: '100%',
                      fontWeight: 'bold',
                      fontSize: '15px',
                      caretColor: 'Background',
                      cursor: 'pointer',
                    }}
                    type="submit"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    Send Password
                  </button>
                </Box>
              )}
            </Formik>

            <div className="" style={{ display: 'flex', justifyContent: 'center ', marginTop: '10px' }}>
              <p>Click here to </p>
              <span
                className=""
                style={{ color: 'blue', cursor: 'pointer' }}
                onClick={() => {
                  navigate('/login');
                }}
              >
                &nbsp;Login
              </span>
            </div>
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
